import { Panel, PanelHeader } from '@/components/ui/Panel';
import { ThemeToggle } from '@/components/ThemeToggle';

/**
 * The theme control used to live in the mobile navigation sheet. With the sheet
 * replaced by a bottom tab bar it belongs here, next to the other preferences —
 * spending one of four tab slots on it would have cost a destination.
 */
export function AppearanceSection() {
  return (
    <Panel padding="none">
      <PanelHeader
        title="Оформление"
        description="Светлая, тёмная или как в системе. Настройка запоминается на этом устройстве."
      />

      <div className="flex flex-wrap items-center justify-between gap-4 px-4 py-4">
        <p className="max-w-prose text-sm leading-normal text-fg-secondary">
          Тёмная тема заметно спокойнее ночью; «как в системе» переключается сама вместе с
          телефоном.
        </p>
        <ThemeToggle />
      </div>
    </Panel>
  );
}
